import React, { useState, useEffect } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { Toaster, toast } from 'react-hot-toast';
import '../styles/home.css';
import '../styles/spinner.css';
import chica from '../assets/chicaheader.png';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const Home = () => {
    const [invoiceCode, setInvoiceCode] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        purchaseDate: '',
        productName: '',
        email: '',
        phone: '',
        purchaseLocation: '',
        barcode: '',
    });
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);
    const [isGarantiaValidada, setIsGarantiaValidada] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const email = urlParams.get('email');

        if (code && email) {
            verificarGarantia(code, email);
        }
    }, []);

    const decodeBase64 = (str) => {
        return decodeURIComponent(atob(str));
    };

    const verificarGarantia = async (code, email) => {
        try {
            let decodedCode = decodeBase64(code);
            const decodedEmail = decodeBase64(email);

            decodedCode = decodedCode.replace('FACEL-', '').replace('-NVC01', '');

            const response = await fetch(
                `${API_URL}/validar-garantia?code=${encodeURIComponent(decodedCode)}&email=${encodeURIComponent(decodedEmail)}`
            );
            const data = await response.json();

            if (data.garantiaValida) {
                setIsGarantiaValidada(true);
                toast.success('Garantía validada correctamente');
            } else {
                toast.error('Error al validar la garantía');
            }
        } catch (error) {
            toast.error('Error al validar la garantía');
            console.error('Error al validar la garantía:', error);
        }
    };

    const handleInvoiceCodeChange = (e) => {
        setInvoiceCode(e.target.value);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleNombreChange = (e) => {
        const value = e.target.value;
        if (/^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]*$/.test(value)) {
            setFormData({ ...formData, name: value });
        }
    };

    const handleCorreoChange = (e) => {
        const value = e.target.value;
        if (!/\s/.test(value)) {
            setFormData({ ...formData, email: value });
        }
    };

    const handleKeyPressCorreo = (e) => {
        if (e.key === ' ') e.preventDefault();
    };

    const handleTelefonoChange = (e) => {
        const value = e.target.value;
        if (/^[0-9]*$/.test(value)) {
            setFormData({ ...formData, phone: value });
        }
    };

    const handleTermsChange = (e) => {
        setIsTermsAccepted(e.target.checked);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await fetch(`${API_URL}/registrar-garantia`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    codigoFactura: invoiceCode,
                    nombre: formData.name,
                    fechaCompra: formData.purchaseDate,
                    nombreComercialProducto: formData.productName,
                    correo: formData.email,
                    telefono: formData.phone,
                    localDeCompra: formData.purchaseLocation,
                    isTermsAccepted: isTermsAccepted,
                    codigoBarras: formData.barcode || null,
                })
            });
            const data = await response.json();
            if (!response.ok || data.error) {
                toast.error(data.error || 'Error al enviar el formulario');
            } else {
                setSubmitted(true);
                setInvoiceCode('');
                setFormData({ name: '', purchaseDate: '', productName: '', email: '', phone: '', purchaseLocation: '', barcode: '' });
                setIsTermsAccepted(false);
            }
        } catch (error) {
            toast.error('Error al enviar el formulario');
            console.error('Error al enviar el formulario:', error);
        }
    };

    const isFormValid =
        invoiceCode.trim() &&
        formData.name.trim() &&
        formData.purchaseDate &&
        formData.productName.trim() &&
        formData.email.trim() &&
        formData.phone.trim() &&
        formData.purchaseLocation.trim() &&
        isTermsAccepted;

    const currentDate = new Date().toISOString().split('T')[0];

    return (
        <>
            <div className='home'>
                <div className='header'>
                    <h1 className='header-title'>Validación de Garantía</h1>
                    <img src={chica} alt='Chica sonriendo con hoja de garantía' width='200' height='200' className='header-image' />
                </div>

                <Container className='content' xs={12} md={8} lg={6}>
                    <Toaster position="top-right" reverseOrder={false} />
                    {submitted ? (
                        <div style={{ textAlign: 'center', padding: '40px 16px' }}>
                            <div style={{
                                width: 84, height: 84, borderRadius: '50%',
                                backgroundColor: '#e11d2a', display: 'flex',
                                alignItems: 'center', justifyContent: 'center',
                                margin: '0 auto 24px',
                                boxShadow: '0 8px 24px rgba(225, 29, 42, 0.3)'
                            }}>
                                <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12" />
                                </svg>
                            </div>
                            <h2 style={{ color: '#0a0a0a', fontWeight: 800, marginBottom: 12, letterSpacing: '-0.02em' }}>¡Garantía registrada!</h2>
                            <p style={{ color: '#141414', fontSize: 16, marginBottom: 8 }}>Tu garantía fue registrada correctamente.</p>
                            <p style={{ color: '#52525b', fontSize: 14 }}>Revisa tu correo electrónico para el enlace de confirmación.</p>
                            <button
                                onClick={() => setSubmitted(false)}
                                style={{ marginTop: 32, padding: '13px 30px', backgroundColor: '#e11d2a', color: 'white', border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 15, fontWeight: 700 }}
                            >
                                Registrar otra garantía
                            </button>
                        </div>
                    ) : isGarantiaValidada ? (
                        <div className='validacion-exitosa'>
                            <h2>Tu garantía ya ha sido validada.</h2>
                        </div>
                    ) : (
                        <div className='invoice-section'>
                            <Form onSubmit={handleSubmit} className="user-form mt-4 invoice-form">

                                <Form.Group controlId="formInvoiceCode">
                                    <Form.Label className="mb-3">Código de Factura <span style={{ color: 'red' }}>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={invoiceCode}
                                        onChange={handleInvoiceCodeChange}
                                        placeholder="Ingrese el código de factura"
                                        className="input-invoice-code"
                                        maxLength="255"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formName">
                                    <Form.Label>Nombre <span style={{ color: 'red' }}>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleNombreChange}
                                        placeholder="Ingrese su nombre completo"
                                        className="input-invoice-code"
                                        maxLength="100"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formPurchaseDate">
                                    <Form.Label>Fecha de Compra <span style={{ color: 'red' }}>*</span></Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="purchaseDate"
                                        value={formData.purchaseDate}
                                        onChange={handleInputChange}
                                        min="2000-01-01"
                                        max={currentDate}
                                        className="input-invoice-code"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formProductName">
                                    <Form.Label>Nombre Comercial del Producto <span style={{ color: 'red' }}>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="productName"
                                        value={formData.productName}
                                        onChange={handleInputChange}
                                        placeholder="Ingrese el nombre del producto"
                                        className="input-invoice-code"
                                        maxLength="150"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formEmail">
                                    <Form.Label>Correo Electrónico <span style={{ color: 'red' }}>*</span></Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onKeyPress={handleKeyPressCorreo}
                                        onChange={handleCorreoChange}
                                        placeholder="Ingrese su correo electrónico"
                                        className="input-invoice-code"
                                        maxLength="100"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formPhone">
                                    <Form.Label>Teléfono <span style={{ color: 'red' }}>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleTelefonoChange}
                                        placeholder="Ingrese su teléfono"
                                        className="input-invoice-code"
                                        maxLength="20"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formPurchaseLocation">
                                    <Form.Label>Local de Compra <span style={{ color: 'red' }}>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="purchaseLocation"
                                        value={formData.purchaseLocation}
                                        onChange={handleInputChange}
                                        placeholder="Ingrese el local donde realizó la compra"
                                        className="input-invoice-code"
                                        maxLength="150"
                                        required
                                    />
                                </Form.Group>

                                <Form.Group controlId="formBarcode">
                                    <Form.Label>Número de Serie</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="barcode"
                                        value={formData.barcode}
                                        onChange={handleInputChange}
                                        placeholder="Ingrese el número de serie del producto"
                                        className="input-invoice-code"
                                        maxLength="50"
                                    />
                                </Form.Group>

                                <Form.Group controlId="formTerms">
                                    <Form.Check
                                        type="checkbox"
                                        label={<span>Acepto los <a href="https://www.iubenda.com/privacy-policy/36820790/legal" target="_blank" rel="noopener noreferrer">términos y condiciones</a></span>}
                                        className="checkbox-terms"
                                        checked={isTermsAccepted}
                                        onChange={handleTermsChange}
                                    />
                                </Form.Group>

                                <br />
                                <Button variant="primary" type="submit" className="btn-invoice-code" disabled={!isFormValid}>
                                    Enviar
                                </Button>
                            </Form>
                        </div>
                    )}
                </Container>
            </div>
        </>
    );
};

export default Home;
